export default "__VITE_ASSET__CTz7h6xK__"